export default __webpack_public_path__ + "static/media/education.4011a2cb.png";